<template>
  <div :class="[pageClass, 'shopping_mall']">
    <div class="header">
      <table
        width="1200"
        border="0"
        align="center"
        cellpadding="0"
        cellspacing="0"
        class="text-01 h120"
      >
        <tr>
          <td>
            <table
              width="100%"
              border="0"
              align="center"
              cellpadding="0"
              cellspacing="0"
              class="text-01 h120"
              style="font-size:16px;"
            >
              <tr>
                <td width="230">
                  <img src="/web/images/logo.png" width="230" class="h120" />
                </td>
                <td>&nbsp;</td>
                <td
                  width="100"
                  class="tab-list"
                  style="cursor: pointer"
                  @click="tabChange(1)"
                >
                  <div align="center">
                    <p class="content">
                      <a href="/web/index.html">首页</a>
                    </p>
                  </div>
                </td>
                <td
                  width="100"
                  class="tab-list"
                  style="cursor: pointer"
                  @click="tabChange(2)"
                >
                  <div align="center">
                    <p class="content">
                      <a href="/web/main/01-01.html">产品</a>
                      <img
                        id="_arrow_nav"
                        src="../../../../public/web/images/arrow_nav_d.png"
                        alt=""
                      />
                    </p>
                  </div>
                  <div class="_product_list product_list">
                    <table
                      width="100%"
                      height="60"
                      border="0"
                      align="center"
                      cellpadding="0"
                      cellspacing="0"
                      bgcolor="#4981e9"
                      class="text-01"
                    >
                      <tr>
                        <td>
                          <table
                            width="400"
                            height="40"
                            border="0"
                            align="center"
                            cellpadding="0"
                            cellspacing="0"
                            class="text-01"
                          >
                            <tr>
                              <td width="100">
                                <div align="center">
                                  <p class="content">
                                    <a href="/web/main/01-01.html">
                                      <font color="#FFFFFF">产品介绍</font>
                                    </a>
                                  </p>
                                </div>
                              </td>
                              <td width="100">
                                <div align="center">
                                  <p class="content">
                                    <a href="/web/main/01-02.html">
                                      <font color="#FFFFFF">产品动态</font>
                                    </a>
                                  </p>
                                </div>
                              </td>
                              <td width="100">
                                <div align="center">
                                  <p class="content">
                                    <a href="/web/main/01-03.html">
                                      <font color="#FFFFFF">软件下载</font>
                                    </a>
                                  </p>
                                </div>
                              </td>
                              <td width="120">
                                  <div align="center">
                                    <p class="content">
                                      <a href="/#/web/vip_card_active">
                                        <font color="#FFFFFF">软件卡激活</font>
                                      </a>
                                    </p>
                                  </div>
                                </td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                    </table>
                  </div>
                </td>
                <td
                  width="100"
                  class="tab-list"
                  style="cursor: pointer"
                  @click="tabChange(3)"
                >
                  <div align="center">
                    <p class="content"><a href="/#/shopping_mall">商城</a></p>
                  </div>
                </td>
                <td
                  width="100"
                  class="tab-list"
                  style="cursor: pointer"
                  @click="tabChange(4)"
                >
                  <div align="center">
                    <p class="content">
                      <a href="/web/main/03.html">服务网点</a>
                    </p>
                  </div>
                </td>
             
                <!-- <td
                  width="100"
                  class="tab-list"
                  style="cursor: pointer; background: #1e50ae"
                  @click="tabChange(6)"
                >
                  <div align="center">
                    <p class="content">
                      <a style="color: #ffffff" href="/web/main/05-01.html"
                        >会员中心</a
                      >
                    </p>
                  </div>
                </td> -->
                <td
                  width="100"
                  class="tab-list"
                  style="cursor: pointer"
                  @click="tabChange(7)"
                >
                  <div align="center">
                    <p class="content">
                      <a href="/web/main/06.html">专家介绍</a>
                    </p>
                  </div>
                </td>
                   <td
                  width="100"
                  class="tab-list"
                  style="cursor: pointer"
                  @click="tabChange(5)"
                >
                  <div align="center">
                    <p class="content">
                      <a href="/web/main/04.html">关于我们</a>
                    </p>
                  </div>
                </td>
                <td width="100" class="tab-list" style="cursor: pointer;">
                  <div align="center">
                    <p class="content"><a href="/web/main/07-01.html">帮助中心</a></p>
                  </div>
                </td>
                <td width="100" style="cursor: pointer">
                  <div class="user_avatar _user_avatar"  v-if="isLogin">
                    <!-- <img class="_avatar_img" :src="imgUrl" /> -->
                     <div style="color:#5c307d;font-size:16px;">个人中心</div>
                    <ul class="data-list _data_list" style="font-size:14px;">
                      <li><a href="/#/web/setting">账号设置</a></li>
                      <li><a href="/#/web/vip_card_active">软件卡激活</a></li>
                      <li><a href="/#/web/purchased">我的已购</a></li>
                      <li><a href="/#/web/coordinator">班主任服务</a></li>
                      <li @click="webLogout">退出登录</li>
                    </ul>
                  </div>
                  <div class="_no_login" v-else>
                    <p class="content" style="text-align: center">
                      <a href="/#/web_login_register">登录/注册</a>
                    </p>
                  </div>
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </div>
    <div class="header-sticky"></div>
    <div :class="[`${pageClass}-main`]">
      <div :class="[`${pageClass}-main-content`]">
        <div class="line"></div>
        <el-tabs tab-position="top" style="height: 100%" v-model="reverieve">
          <el-tab-pane label="找回密码" name="reverieve">
            <el-button type="primary" class="back" @click="goBack"
              >返回</el-button
            >
            <template v-if="!setPwd">
              <input
                class="reverieve_item"
                v-model="contactNumber"
                type="text"
                placeholder="请输入手机号"
              />
              <slide-verify
                ref="slideblock"
                @again="onAgain"
                @fulfilled="onFulfilled"
                @success="onSuccess"
                @fail="onFail"
                @refresh="onRefresh"
                :accuracy="accuracy"
                :slider-text="text"
                style="margin: 0 auto"
              ></slide-verify>
              <div class="slidetips">{{ msg }}</div>
              <button class="next_btn" @click="nextStep">下一步</button>
            </template>

            <template v-else>
              <div class="pwdtitle">设置新密码：</div>
              <input
                class="pwdinput"
                v-model="newPwd"
                type="password"
                placeholder="请输入新密码"
              />
              <button class="next_btn" @click="submitpwd">提交</button>
            </template>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div v-if="model != 'client'" :class="[`${pageClass}-footer`]">
      <Footer></Footer>
    </div>
    <!-- 手机短信验证码  -->
    <el-dialog
      title="手机短信验证码"
      :visible.sync="mobileDialogVisible"
      center
    >
      <div class="top-img">
        <img src="@/assets/images/login/mobile.png" alt="" />
      </div>
      <p class="tips">当前手机号: {{ mobile }}</p>
      <div class="verify">
        <input
          class="verify_input"
          v-model="very_code"
          placeholder="请输入验证码"
          onkeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
          oninput="if(value.length>6)value=value.slice(0,6)"
        />
        <div
          class="verify_code"
          :style="{
            color: isSend ? '#585858' : '#5c307d',
            cursor: isSend ? '' : 'pointer',
          }"
          @click="getCode"
        >
          <img src="@/assets/images/login/envelope.png" alt="" />
          <span>{{ timing }}</span>
        </div>
      </div>
      <div class="next_btn">
        <button @click="nestVerify">下一步</button>
      </div>
      <h3>收不到短信验证码？</h3>
      <p>
        请检查手机网络并且核实手机是否屏蔽系统短信，如均正常请重新获取或
        稍后再试。
      </p>
    </el-dialog>
    <!-- 电子邮箱验证码  -->
    <!-- <el-dialog
            title="电子邮箱验证码"
            :visible.sync="mailDialogVisible"
            width="30%"
            center>
            <span>需要注意的是内容是默认不居中的</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="centerDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
            </span>
        </el-dialog> -->
  </div>
</template>

<script>
import $ from "jquery";
import config from '@/config/config.js'
export default {
  name: "web_layout_p",
  data() {
    return {
      baseUrl: `${config.backURL}/`,
      isLogin: false,
      imgUrl: "",
      model: "",
      pageClass: "reverieve_password",
      reverieve: "reverieve",
      msg: "",
      text: "向右滑",
      // 精确度小，可允许的误差范围小；为1时，则表示滑块要与凹槽完全重叠，才能验证成功。默认值为5
      accuracy: 1,
      contactNumber: "", // 输入手机号 或者邮箱
      verification: false,
      mailDialogVisible: false,
      mobileDialogVisible: false,
      mobile: "",
      //验证码相关
      very_code: "", // 验证码
      timing: "获取短信验证码",
      generate_verify_code: "",
      isSend: false,
      countdown: 60,
      setPwd: false,
      newPwd: "",
    };
  },
  methods: {
    toSetting () {
        window.location.href =  '/#/web/setting'
    },
    toPurchased () {
        window.location.href =  '/#/web/purchased'
    },
    webLogout() {
        localStorage.clear()
        window.location.href = '/web/index.html'
    },
    tabChange (val) {
      switch (val) {
        case 1:
          window.location.href =  'web/index.html'
          break;
        case 2:
          window.location.href = 'web/main/01-01.html'
          break;
        case 3:
          window.location.href =  '/#/shopping_mall'
          break;
        case 4:
          window.location.href = 'web/main/03.html'
          break;
        case 5:
          window.location.href = 'web/main/04.html'
          break;
        case 6:
          window.location.href =  'web/main/05-01.html'
          break;
        case 7:
          window.location.href =  'web/main/06.html'
          break;
      }
    },
    goBack() {
      window.location.href =  'web/index.html'
      // 是否登陆的判断
      //   if(!window.localStorage.getItem("isLogin")) {
      //     this.$router.push({
      //       'path': '/tfedu_common/home'
      //     })
      //   } else {
      //     if (this.model != 'client') {
      //       this.$router.push({
      //         'path': '/my-personal/setting'
      //       })
      //     } else {
      //       this.$router.push({
      //         'path': '/client_setting'
      //       })
      //     }
      //   }
    },
    onSuccess(times) {
      this.msg = `验证通过，耗时${(times / 1000).toFixed(1)}秒`;
      this.verification = true; // 验证通过
    },
    onFail() {
      this.msg = "验证失败！";
      this.verification = false; // 验证失败
    },
    onRefresh() {
      // this.msg = ''
      this.verification = false; // 验证失败
    },
    onFulfilled() {
      console.log("刷新成功啦！");
      this.msg = "";
    },
    onAgain() {
      console.log("检测到非人为操作的哦！");
      this.msg = "非人为操作的哦！";
      this.verification = false;
      // 刷新
      this.$refs.slideblock.reset();
    },
    handleClick() {
      // 父组件直接可以调用刷新方法
      this.$refs.slideblock.reset();
    },
    // 点击下一步操作
    nextStep() {
      const regEmail = /^([a-z0-9_\.-]+)@([\da-z\.-]+)\.([a-z\.]{2,6})$/;
      const regMobile = /^0?1[3|4|5|6|7|8|9][0-9]\d{8}$/;

      let mailflag = regEmail.test(this.contactNumber);
      let mobileflag = regMobile.test(this.contactNumber);
      let userinfo = localStorage.getItem("userinfo");
      const user = JSON.parse(userinfo);

      if (!this.contactNumber) {
        this.$message.error("请输入手机号！");
        return false;
      }
      if (!mailflag && !mobileflag) {
        this.$message.error("手机号输入错误！");
        return false;
      } else if (
        user != null &&
        user.mobilePhone != null &&
        this.contactNumber != user.mobilePhone
      ) {
        this.$message.error("手机号不是当前帐号绑定的手机号，请检查后再试！");
        return false;
      } else {
        if (!this.verification) {
          this.$message.error("请滑动滑块验证图片！");
          return false;
        }
        if (mailflag) {
          this.$message({
            type: "wrong",
            message: "暂不支持邮箱找回密码",
          });
        }
        if (mobileflag) {
          this.mobile =
            this.contactNumber.substr(0, 3) +
            "****" +
            this.contactNumber.substr(7);
          this.mobileDialogVisible = true;
        }
      }
    },
    getCode() {
      // if (this.countdown != 60) return;
      if (!this.isSend) {
        this.isSend = true;
        //生成一个6位数的验证码
        this.generate_verify_code = Math.random().toString().substring(2, 8);
        //发送请求
        let data = {
          mobile: this.contactNumber, // this.ruleForm.phone
          "verify-code": this.generate_verify_code,
        };
        this.$HTTP
          .executePost(this.$APIS.USER_LOGIN_CODE, data, this)
          .then((response) => {
            if (response.msg == "Success!") {
              //验证码有效期为1分钟,存到store中,设置有效期
              this.$message.success("请求验证码成功!");
              let code = {
                very_code: this.generate_verify_code,
                time_end: new Date().getTime() + 10 * 60 * 1000,
              };
              window.localStorage.setItem("edit_code", JSON.stringify(code));

              if (this.isSend) {
                this.timer = setInterval(() => {
                  if (this.countdown >= 0 && this.countdown <= 60) {
                    this.countdown--;
                    if (this.countdown >= 0) {
                      this.timing = this.countdown + "s";
                    } else {
                      clearInterval(this.timer);
                      this.timing = "获取短信验证码";
                      this.countdown = 60;
                      this.isSend = false;
                    }
                  }
                }, 1000);
              } else {
                this.isSend = false;
              }
            } else {
              this.$message.error(response.msg);
              this.isSend = false;
            }
          });
      }
    },
    // 验证手机二维码是否正确
    nestVerify() {
      if (!this.very_code) {
        this.$message.error("请输入验证码");
        return false;
      }
      let codes = window.localStorage.getItem("edit_code");
      let codeStr = JSON.parse(codes);
      if (this.generate_verify_code == this.very_code) {
        this.setPwd = true;
        this.mobileDialogVisible = false;
      } else {
        this.$message.error("验证码输入错误！");
      }
    },
    submitpwd() {
      let patrn = /^(\w){6,20}$/;
      if (!patrn.exec(this.newPwd)) {
        this.$message.error("只能输入6-20个字母、数字、下划线");
      } else {
        // let userinfo = localStorage.getItem('userinfo');
        // const userId = JSON.parse(userinfo).id
        const dataParams = {
          password: this.newPwd,
          username: this.contactNumber,
        };
        this.$HTTP
          .executePost(this.$APIS.RESET_PASSWORD, dataParams, this)
          .then((res) => {
            if (!res.code) {
              this.$message.success("修改密码成功,请重新登录");
              this.$root.eventHub.$emit("changePath", "home");
              // this.$router.push({
              //     path: "/client_setting?active_name=2",
              //     query: {
              //         t: new Date().getTime()
              //     }
              // });
              this.$router.push({
                path: "/web/setting",
                query: {
                  active_name: "2",
                },
              });
            } else {
              this.$message.error(res.msg);
            }
          });
      }
    },
  },
  created() {
    this.model = localStorage.getItem("model") || "";
    this.isLogin =
      window.localStorage.getItem("isLogin") == "true" ? true : false;
    // this.ruleForm.username = this.$cookies.get('LoginUserName') || null
    var userLogin = localStorage.getItem("isLogin") || "";
    if (userLogin === "true") {
      var userinfo = JSON.parse(localStorage.getItem("userinfo"));
      try {
        this.imgUrl = this.baseUrl +  userinfo.avatar
      } catch (error) {
        this.imgUrl = require("../../../../public/web/images/user.png");
        console.log(error);
      }
      this.isLogin = true;
    } else {
      this.isLogin = false;
    }
  },
  mounted() {
    $(function () {
      $(".tab-list").hover(
        function () {
          $(this)
            .find("#_arrow_nav")
            .attr(
              "src",
              require("../../../../public/web/images/arrow_nav_u.png")
            );
          $(this).addClass("active");
          if ($(this).index() == 3) {
            $("._product_list").show();
          }
        },
        function () {
          $(this)
            .find("#_arrow_nav")
            .attr(
              "src",
              require("../../../../public/web/images/arrow_nav_d.png")
            );
          $(this).removeClass("active");
          if ($(this).index() == 3) {
            $("._product_list").hide();
          }
        }
      );
      $("._user_avatar").hover(
        function () {
          $("._data_list").show();
        },
        function () {
          $("._data_list").hide();
        }
      );
    });
  },
};
</script>
<style>
</style>

<style lang="stylus" scoped>
html, body {
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

.reverieve_password {
  height: 100%;

  &-header {
    height: 120px;
    width: 100%;
    position: absolute;
    z-index: 5;
    top: 0;
  }

  &-main {
    width: 100%;
    overflow: auto;
    top: 120px;
    position: absolute;
    z-index: 10;
    bottom: 43px;
    background-color: #efefef;

    &-content {
      width: 1520px;
      height: auto;
      margin: 0 auto;
      position: relative;
      background-color: #ffffff;

      .line {
        height: 30px;
        background-color: #efefef;
      }

      /deep/ .el-tabs--border-card {
        background: none;
        border: none;
        box-shadow: none;
      }

      /deep/ .el-tabs__content {
        position: relative;

        .back {
          position: absolute;
          right: 100px;
          top: 0px;
          z-index: 20px;
          background-color: #5c307d;
        }
      }

      /deep/ .el-tabs {
        width: 100%;
        height: 100%;
        margin-top: 50px;

        .el-tabs__item {
          font-size: 18px;
          padding: 0 95px !impontent;
          color: #5c307d;
          height: 50px;
          line-height: 50px;
        }

        .el-tabs__item:last-child {
          padding: 0 95px;
        }

        .el-tabs__item:first-child {
          padding: 0 95px;
        }

        .el-tabs__item:nth-child(2) {
          padding: 0 95px;
        }

        .el-tabs__nav-wrap::after {
          background-color: #ffffff;
        }

        .el-tabs__item.is-active {
          color: #ffffff;
          background-color: #5c307d;
        }

        .el-tabs__header {
          border-bottom: 3px solid #5c307d;
        }

        .el-tabs__header .el-tabs__item:not(.is-disabled):hover {
          color: #ffffff;
          background-color: #5c307d;
        }

        .el-tabs__active-bar {
          background-color: transparent;
        }

        .slidetips {
          font-size: 14px;
          text-align: center;
          line-height: 40px;
          color: #7a8f9a;
        }

        .reverieve_item {
          width: 498px;
          height: 58px;
          display: block;
          border: 1px solid #5c307d;
          margin: 100px auto 50px auto;
          padding: 0 20px;
          font-size: 18px;
        }

        .next_btn {
          width: 337px;
          height: 50px;
          color: #ffffff;
          font-size: 21px;
          border: none;
          border-radius: 25px;
          margin: 30px auto;
          display: block;
          background-color: #5c307d;
          cursor: pointer;
        }

        .pwdtitle {
          width: 498px;
          margin: 0 auto;
          margin-top: 100px;
        }

        .pwdinput {
          width: 498px;
          height: 58px;
          display: block;
          border: 1px solid #5c307d;
          margin: 10px auto 50px auto;
          padding: 0 20px;
          font-size: 18px;
        }
      }
    }
  }

  &-footer {
    height: 43px;
    width: 100%;
    position: absolute;
    z-index: 200;
    bottom: 0;
  }
}

/deep/ .el-dialog {
  width: 655px;
  height: 476px;

  .el-dialog__header {
    padding: 0;
    height: 40px;
    background-color: #5c307d;
    text-align: center;
    font-size: 16px;
    line-height: 40px;

    .el-dialog__title {
      color: #fff;
    }

    .el-dialog__headerbtn {
      font-size: 25px;
      top: 10px;
    }
  }

  .el-dialog__body {
    .top-img {
      width: 100%;
      height: 106px;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        width: 70px;
        height: 70px;
      }
    }

    .tips {
      width: 100%;
      text-align: center;
      color: #585858;
      font-size: 18px;
    }

    .verify {
      height: 50px;
      display: flex;
      justify-content: space-evenly;
      margin-top: 26px;

      .verify_input {
        width: 238px;
        height: 48px;
        border: 1px solid #5c307d;
        padding-left: 10px;
        display: inline-block;
      }

      .verify_code {
        width: 238px;
        height: 48px;
        border: 1px solid #5c307d;
        padding-left: 10px;
        display: inline-block;

        img {
          width: 32px;
          height: 22px;
          margin-top: 13px;
          vertical-align: -5px;
        }

        span {
          margin-left: 30px;
          font-size: 16px;
        }
      }
    }

    .next_btn {
      text-align: center;

      button {
        width: 336px;
        height: 52px;
        border-radius: 26px;
        background-color: #5c307d;
        border: none;
        outline: none;
        margin-top: 34px;
        color: #fff;
        cursor: pointer;
      }
    }

    h3 {
      font-size: 16px;
      line-height: 28px;
      margin-top: 25px;
      font-weight: 800;
    }

    p {
      font-size: 16px;
      line-height: 28px;
    }
  }
}
</style>
<style lang="scss" scoped>
.no_login {
  width: 100%;
  font-size: 200px;
  text-align: center;
  line-height: 300px;
  i {
    color: green;
  }
}
.shopping_mall {
  font-size: 16px;
  .header {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
    background: #fff;
    width: 100%;
    // height: 120px;
    // overflow: hidden;
    .h120 {
      height: 120px;
    }
  }
  .tab-list {
    height: 120px;
  }
  .header-sticky {
    width: 100%;
    height: 120px;
  }
  .text-01 {
    margin: 0 auto;
    font-size:16px;
  }
  .active {
    background: #1e50ae;
  }

  .active a {
    color: #fff;
  }

  .active a:hover {
    color: #fff;
  }

  .product_list {
    width: 100%;
    position: fixed;
    top: 120px;
    left: 0;
    z-index: 2;
    display: none;
  }
  td {
    // line-height: 200%;
    .buy-btn {
      cursor: pointer;
    }
  }

  .t-header td {
    height: 75px;
  }
  .t-content td,
  .t-content td p {
    line-height: 2;
    padding: 8px 10px;
  }

  /deep/ .login {
    top: 0;
  }
  .header .user_avatar img {
    width: 35px;
    height: 35px;
    border-radius: 35px;
    border: 2px solid #eee;
    display: inline-block;
  }
  .user_avatar {
    position: relative;
    text-align: center;
  }
  .data-list {
    width: 100px;
    display: block;
    position: fixed;
    top: 40px;
    left: 0px;
    background-color: #fff;
    list-style: none;
    z-index: 100;
    border-radius: 4px;
    padding: 10px 0;
    display: none;
    box-shadow: 0px 0px 8px #ccc;
  }
  .data-list li {
    width: 100%;
    height: 30px;
    line-height: 30px;
    text-align: center;
  }
  .data-list li:hover {
    background-color: #1e50ae;
    color: #fff;
  }
}
</style>